import { render, staticRenderFns } from "./JobfairSettingsForm.vue?vue&type=template&id=7ae4ac52&scoped=true"
import script from "./JobfairSettingsForm.vue?vue&type=script&lang=js"
export * from "./JobfairSettingsForm.vue?vue&type=script&lang=js"
import style0 from "./JobfairSettingsForm.vue?vue&type=style&index=0&id=7ae4ac52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae4ac52",
  null
  
)

export default component.exports